import PlayerNameCell from './PlayerNameCell';

export default PlayerNameCell;
